import React, { useState, useCallback, useRef, useEffect } from 'react'
import { ReactComponent as CloseIcon } from '../img/ic_cerrar.svg';
import { connect } from 'react-redux'
import { fileUploadProfileImage } from '../actions/fileUploadActions'



import Cropper from 'react-easy-crop'
import { getCroppedImg, getRotatedImage } from './canvasUtils'
import { Translate } from '../language';
import { urlServer } from '../config/GlobalConstant';
import { searchListProfessionalCommunityCategories } from '../admin/actions/categoriesActions';
import Button from '../utils/components/Button/Button';

function readFile(file) {
    return new Promise((resolve) => {
        const reader = new FileReader()
        reader.addEventListener('load', () => resolve(reader.result), false)
        reader.readAsDataURL(file)
    })
}

const ModalPictureProfile = ({  setFile, seturlProfilePicture = null, isProfessional, profile, history, displayModal, closeModal, fileUploadProfileImage ,newPhoto}) => {

    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }

  

    const cancelFileUpload = () => {
        setImageSrc(null)
    }

    useEffect(() => {
        setRotation(0)
    }, [])
    const imgRef = useRef(null)

    const [imageSrc, setImageSrc] = useState(null)
    const [fileSelected, setFileSelected] = useState(null)

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [rotation, setRotation] = useState(0)
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [croppedImage, setCroppedImage] = useState(null)
    const [isLoadingProfilePicture, setIsloadingProfilePicture] = useState(false)
    const [processingStatus, setProcessingStatus] = useState(1)
    const [description, setDescription] = useState("")

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels)
    }, [])

    const close = (e) => {
        e.stopPropagation()
        if(newPhoto){
            setImageSrc(null)
            setFileSelected(null)
        }
        closeModal(e)
      
    }
    const [upImg, setUpImg] = useState()

    const showCroppedImage = useCallback(async (e) => {
        e.persist()
        console.log();
        setIsloadingProfilePicture(true)
        try {

            const croppedImage = await getCroppedImg(
                imageSrc,
                croppedAreaPixels,
                rotation
            )

           
            const newNameFile = "profile" + '.' + "png";
        

            const img = new File([croppedImage], newNameFile, { type: croppedImage.type });

            const formData = new FormData();
            img.width = 1
            img.height = 1
            if (!newPhoto && seturlProfilePicture != null) {
                console.log();
                seturlProfilePicture(URL.createObjectURL(img))
                setFile(img)
                setIsloadingProfilePicture(false)
                setProcessingStatus(2)
                close(e)
                // setFile(img)


                return

            }
            if(newPhoto){
                formData.append('file', img)
                formData.append('description', description)
                setProcessingStatus(2)
               
                fileUploadProfileImage(formData,setIsloadingProfilePicture,()=>close(e))
            }
         

        

        } catch (e) {
            console.log();
            console.error(e)
        }
    }, [imageSrc, croppedAreaPixels, rotation, description])

    const auto_height = (e) => {
        e.target.style.height = "1px";
        e.target.style.height = (e.target.scrollHeight) + "px";
    }
    const onFileChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0]
            e.target.value = ''
            let imageDataUrl = await readFile(file)
            const rotation = 0
            if (rotation) {
                imageDataUrl = await getRotatedImage(imageDataUrl, rotation)
            }

            setImageSrc(imageDataUrl);
            setFileSelected(file)
        }
    }

    return (
        <div
            className={"modal modal-tag-friend"}
            onClick={close}
            style={divStyle} >
                
            {isLoadingProfilePicture ?
                <div className="new-post-loaging-files">
                    {processingStatus ===1 ? 'Procesando...' : 'Subiendo...'}
                    <div className="progress-bar-container">
                        <div className="progress-bar"></div>
                    </div>
                </div>
                :
                <div
                    className="modal-content modal-content-tag-friend"
                    onClick={e => e.stopPropagation()} >
                    <div onClick={(e) => {
                        cancelFileUpload()
                        close(e)
                    }} className="close-modal">
                        <CloseIcon className="cls-1" height="18" width="18" />
                    </div>
                    <div className='p-5 row centerItems'>
                        <label>
                            <input ref={imgRef} type="file" onChange={(event) => { 
                                 if(event.target.files[0] && event.target.files[0].type.includes('image')){
                                onFileChange(event) }}} accept="image/*" />
                            <Button text='Sube una foto' onClick={()=>imgRef.current.click()}/>
                        </label>
                    </div>
                    {imageSrc &&
                        <React.Fragment>
                            <div className={'container-crop-img'}>
                                <Cropper
                                    image={imageSrc}
                                    crop={crop}
                                    rotation={rotation}
                                    zoomWithScroll={true}
                                    showGrid={false}
                                    minZoom={1}
                                    zoom={zoom}
                                    aspect={1}
                                    onCropChange={setCrop}
                                    onRotationChange={setRotation}
                                    onCropComplete={onCropComplete}
                                    onZoomChange={setZoom}
                                />
                            </div>
                            <div className="column parent-width relative mt-2">
                                <div className="row parent-width pl-5 pr-5 ">
                                <input type="range" min="1" step={0.1}max="3" value={zoom} onChange={(e ) => setZoom(e.target.value)}/>
                                    
                                    <div className="row parent-width centerItems">
                                        Zoom
                                    </div>
                                </div>
                                <div className="row parent-width pl-5 pr-5 ">
                                <input type="range" min="0" step={1} max="360" value={rotation} onChange={(e ) => setRotation(e.target.value)}/>
                                   
                                    <div className="row parent-width centerItems">
                                        Rotación
                                    </div>

                                </div>

                            </div>
                            {
                                false && <div className="scroll-menu mt-1">
                                    <textarea
                                        className='textarea-new-post'
                                        value={description}
                                        onChange={e => {
                                            console.log();
                                            setDescription(e.target.value)
                                        }}
                                        onInput={e => auto_height(e)}
                                        name="description"
                                        type="text"
                                        placeholder={Translate('writes', 'es')} />
                                </div>
                            }
                            <div className="container-buttons-save-profile-picture mt-2">
                                <Button onClick={() => { cancelFileUpload() }} text={Translate('cancel', 'es')} theme="white" />
                                <div className="ml-2 mr-2"></div>
                                <Button onClick={(e) => showCroppedImage(e)} text={Translate('accept', 'es')} />
                            </div>
                        </React.Fragment>
                    }
                </div>
            }
        </div>
    )
}

export default connect(null, { fileUploadProfileImage, })(ModalPictureProfile)